module.exports = __webpack_public_path__ + "img/fire_a_key.f781fb1a.png";